import "./src/styles/bootstrap.min.css";
import "./src/styles/global.less";
import "animate.css/animate.min.css";
export const onServiceWorkerUpdateReady = () => window.location.reload(true);
